export default "__VITE_ASSET__85cf7afc__"